import type { CountryConfig } from './typing';

export const statements: CountryConfig = {
    enabled: true,
    createStatement: true,
    deliveryDefinitions: {
        distribution: ['GEORGE', 'GEORGE_AND_EMAIL'],
        format: ['PDF_A4', 'XML_SEPA', 'TXT_MT940'],
        periodicity: ['DAILY', 'MONTHLY', 'YEARLY'],
        canCreateDefinition: true,
        statementNumberEditable: true,
    },
    showMultiDownloadCard: true,
    hasAsyncBankSigningFeature: true,
};
